import React from "react"
import { Box, Typography } from "@mui/material"

import { dsColorNew } from "@palette"
import { fieldLabelSx, fieldNoteSx, helperSx } from "@components/IdentityEditor/BrandsField"


export { fieldLabelSx, helperSx }

/** A field's label with its `n/max` counter, amber at the cap (UX D6). */
export function FieldLabel({ children, count, max, note, component = 'span' }) {
	const full = max !== undefined && count >= max
	return <Typography component={component} sx={fieldLabelSx}>
		{children}
		{max !== undefined && <Box component="span" sx={{ ...fieldNoteSx, ...(full && { color: dsColorNew.noteAmber }) }}> · {count}/{max}</Box>}
		{!!note && <Box component="span" sx={fieldNoteSx}> · {note}</Box>}
	</Typography>
}

export function Helper({ children, sx = {} }) {
	return <Typography sx={{ ...helperSx, ...sx }}>{children}</Typography>
}

/** One cell of the section's 12-column grid. */
export const Cell = ({ span, children, sx = {} }) => <Box sx={{ gridColumn: `span ${span}`, minWidth: 0, ...sx }}>{children}</Box>

// `AppPillToggle` keys its buttons by value: "Not set" needs a value that is not `null`
export const NOT_SET = '__not_set__'
export const fromPill = (v) => (v === NOT_SET ? null : v)
export const toPill = (v) => (v === null || v === undefined ? NOT_SET : v)
